import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { Port, Unit } from '~/graphql/graphql';
import type { User } from '~/types';

type AuthState = {
  isAuthenticated: boolean;
  user: User | null;
  units: Unit[];
  ports: Port[];
};

const initialState: AuthState = {
  isAuthenticated: false,
  user: null,
  units: [],
  ports: [],
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthenticated(state, action: PayloadAction<boolean>) {
      state.isAuthenticated = action.payload;
    },
    setUser(state, action: PayloadAction<User | null>) {
      state.user = action.payload;
    },
    logout(state) {
      state.isAuthenticated = false;
      state.user = null;
      state.units = [];
      state.ports = [];
    },
    setUnits(state, action: PayloadAction<Unit[]>) {
      state.units = action.payload;
    },
    setPorts(state, action: PayloadAction<Port[]>) {
      state.ports = action.payload;
    },
  },
});

export const { setAuthenticated, setUser, logout, setUnits, setPorts } =
  authSlice.actions;

export default authSlice.reducer;
